<template>
  <c-widget-control-bar>
    <v-form-group :label="$t('white-label.widgets.tradeHistory.controlBar.from')" label-cols="auto">
      <v-form-datepicker
        detached
        boundary="window"
        value-as-date
        :value="controlDateFrom"
        :locale="$i18n.locale"
        :labelHelp="$t('white-label.components.datepicker.labelHelp')"
        :labelPrevMonth="$t('white-label.components.datepicker.labelPrevMonth')"
        :labelCurrentMonth="$t('white-label.components.datepicker.labelCurrentMonth')"
        :labelNextMonth="$t('white-label.components.datepicker.labelNextMonth')"
        :labelPrevYear="$t('white-label.components.datepicker.labelPrevYear')"
        :labelCurrentYear="$t('white-label.components.datepicker.labelCurrentYear')"
        :labelNextYear="$t('white-label.components.datepicker.labelNextYear')"
        @input="$emit('dateFromChange', $event)"
      />
    </v-form-group>
    <v-form-group :label="$t('white-label.widgets.tradeHistory.controlBar.to')" label-cols="auto">
      <v-form-datepicker
        detached
        boundary="window"
        value-as-date
        :value="controlDateTo"
        :locale="$i18n.locale"
        :labelHelp="$t('white-label.components.datepicker.labelHelp')"
        :labelPrevMonth="$t('white-label.components.datepicker.labelPrevMonth')"
        :labelCurrentMonth="$t('white-label.components.datepicker.labelCurrentMonth')"
        :labelNextMonth="$t('white-label.components.datepicker.labelNextMonth')"
        :labelPrevYear="$t('white-label.components.datepicker.labelPrevYear')"
        :labelCurrentYear="$t('white-label.components.datepicker.labelCurrentYear')"
        :labelNextYear="$t('white-label.components.datepicker.labelNextYear')"
        @input="$emit('dateToChange', $event)"
      />
    </v-form-group>
    <v-form-group :label="$t('white-label.widgets.tradeHistory.controlBar.interval.label')" label-cols="auto">
      <v-form-select
        :value="controlInterval"
        @input="$emit('intervalChange', $event)"
        :aria-label="$t('white-label.widgets.tradeHistory.controlBar.interval.label')"
      >
        <option value="D">{{ $t('white-label.widgets.tradeHistory.controlBar.interval.values.daily') }}</option>
        <option value="W">{{ $t('white-label.widgets.tradeHistory.controlBar.interval.values.weekly') }}</option>
        <option value="M">{{ $t('white-label.widgets.tradeHistory.controlBar.interval.values.monthly') }}</option>
        <option value="Q">{{ $t('white-label.widgets.tradeHistory.controlBar.interval.values.quarterly') }}</option>
      </v-form-select>
    </v-form-group>
  </c-widget-control-bar>
</template>

<script>
import CWidgetControlBar from '@custom/widgetContainer/CWidgetControlBar';

export default {
  name: 'w-control-bar',
  components: {
    CWidgetControlBar
  },
  props: {
    controlDateFrom: {
      type: Date,
      required: true
    },
    controlDateTo: {
      type: Date,
      required: true
    },
    controlInterval: {
      type: String,
      required: true
    }
  }
};
</script>
